module.exports = __webpack_public_path__ + "img/footer-09.732ae9a4.png";